import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { SessionStorageService } from '../shared-services/services/session-storage.service';

@Injectable({
    providedIn: 'root'
})
export class EnrollmentGuard  {
    constructor(
        private router: Router,
        private sessionStorageService: SessionStorageService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.sessionStorageService.getAuthToken()) {
            return true;
        } else {
            // not logged in so redirect to login page with the return url
            this.router.navigate(['login'], { queryParams: { returnUrl: state.url }, queryParamsHandling: 'merge' });
            return false;
        }
    }
}
